// src/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    html {
        scroll-behavior: smooth;
        -webkit-tap-highlight-color: transparent;
        height: 100%; // Kluczowe
        overflow-x: hidden; // Zapobiega poziomemu scrollowaniu
    }

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        -webkit-touch-callout: none;
    }

    body {
        font-family: ${({ theme }) => theme.fonts.main};
        background-color: ${({ theme }) => theme.colors.background};
        color: ${({ theme }) => theme.colors.textMedium};
        line-height: 1.6;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        font-size: 16px;
        height: 100%; // Kluczowe
        overflow-x: hidden; // Zapobiega poziomemu scrollowaniu body
        // overscroll-behavior-y: contain; // Może pomóc, ale ostrożnie, może blokować "pull to refresh"
    }

    // Usunięto body.dashboard-active, sidebar-open, bo overflow:hidden na body może być problematyczne
    // Lepiej zarządzać overflow na poziomie konkretnych kontenerów

    #root {
        height: 100%; // Kluczowe
        display: flex;
        flex-direction: column;
        overflow: hidden; // Zapobiega scrollowaniu #root, jeśli PageWrapper/AppContainer mają własne
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    .custom-scrollbar::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.colors.primaryLightest + '60'};
        border-radius: 10px;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.colors.primaryLighter};
        border-radius: 10px;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: ${({ theme }) => theme.colors.primaryLight};
    }
    .custom-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.colors.primaryLighter} ${({ theme }) => theme.colors.primaryLightest + '60'};
    }

    a {
        color: ${({ theme }) => theme.colors.primary};
        text-decoration: none;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
            color: ${({ theme }) => theme.colors.primaryDark};
        }
    }

    button, input[type="button"], input[type="submit"], input[type="reset"] {
        font-family: inherit;
        cursor: pointer;
        border: none;
        padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
        font-size: 0.95rem;
        min-height: 44px; // Dobra praktyka dla dotyku
        min-width: 44px; // Dobra praktyka dla dotyku
        display: inline-flex;
        align-items: center;
        justify-content: center;
        -webkit-tap-highlight-color: transparent;
    }

    input, textarea, select {
        font-family: inherit;
        font-size: 1rem;
        padding: ${({ theme }) => theme.spacing.sm};
        border-radius: ${({ theme }) => theme.borderRadius};
        border: 1px solid ${({ theme }) => theme.colors.borderColor};
        -webkit-tap-highlight-color: transparent;
        &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.colors.primary};
            box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryLightest};
        }
    }
    input[type="text"],
    input[type="email"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    input[type="url"],
    textarea {
        -webkit-appearance: none; // Usuwa domyślne style iOS
        -moz-appearance: none;
        appearance: none;
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: ${({ theme }) => theme.fonts.headings};
        color: ${({ theme }) => theme.colors.textDark};
        line-height: 1.3;
        word-break: break-word;
    }

    h1 { font-size: 2rem; @media (max-width: 768px) { font-size: 1.5rem; } }
    h2 { font-size: 1.75rem; @media (max-width: 768px) { font-size: 1.2rem; } }
    h3 { font-size: 1.375rem; @media (max-width: 768px) { font-size: 1.1rem; } }
    h4 { font-size: 1.125rem; @media (max-width: 768px) { font-size: 1rem; } }

    input, textarea {
        -webkit-user-select: text;
        -khtml-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text;
    }
`;